import { useEffect, useId, useRef, useState } from "react";
import useDialog from "../hooks/useDialog";
import { createActivityPreview } from "../data/teacherWorkApi";
import { CloseIcon } from "./Icons";
import ui from "./ui.module.css";

const ActivityPreviewDialog = ({ classroomId, activityId, onClose }) => {
  const titleId = useId();
  const closeRef = useRef(null);
  useDialog(onClose, closeRef);
  const [state, setState] = useState({ status: "loading", url: null });
  // Each launch code works once, so trying again asks for a fresh one.
  const [attempt, setAttempt] = useState(0);

  useEffect(() => {
    let active = true;
    setState({ status: "loading", url: null });
    createActivityPreview({ classroomId, activityId }).then(
      ({ previewUrl }) => active && setState({ status: "ready", url: previewUrl }),
      () => active && setState({ status: "error", url: null })
    );
    return () => { active = false; };
  }, [classroomId, activityId, attempt]);

  return (
    <div className={ui.sheetBackdrop} role="presentation">
      <section className={`${ui.sheet} ${ui.previewSheet}`} role="dialog" aria-modal="true" aria-labelledby={titleId}>
        <div className={ui.row}>
          <div>
            <h2 id={titleId}>Learner preview</h2>
            <p className={ui.meta}>This is what learners see. Nothing you do here is saved.</p>
          </div>
          <button ref={closeRef} type="button" className={ui.iconButton} onClick={onClose} aria-label="Close preview">
            <CloseIcon />
          </button>
        </div>
        {state.status === "loading" && <p role="status">Opening learner view…</p>}
        {state.status === "error" && (
          <div className={ui.stack} role="alert">
            <p className={ui.error}>The preview could not open. Check your connection and try again.</p>
            <button type="button" className={`${ui.button} ${ui.secondary}`} onClick={() => setAttempt((n) => n + 1)}>
              Try again
            </button>
          </div>
        )}
        {state.url && <iframe className={ui.previewFrame} title="Learner activity preview" src={state.url} />}
      </section>
    </div>
  );
};

export default ActivityPreviewDialog;
